var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / MK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-MK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#E81B26",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-12",
    fill: "#FFE94F",
    mask: "url(#mask-2)",
    cx: 14,
    cy: 10,
    r: 3.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8980108,13.4865309 L1.96165435,23.5306406 L-0.714868071,20.5580613 L10.2079601,12.7205702 C10.4092984,13.0007078 10.6409116,13.2576242 10.8980108,13.4865309 Z M17.7920399,12.7205702 L28.7148681,20.5580613 L26.0383456,23.5306406 L17.1019892,13.4865309 C17.3590884,13.2576242 17.5907016,13.0007078 17.7920399,12.7205702 Z M14.9150306,14.5769934 L16,20 L12,20 L13.0839698,14.5767945 C13.3801701,14.6357484 13.6864744,14.6666667 14,14.6666667 C14.313173,14.6666667 14.6191408,14.6358179 14.9150306,14.5769934 Z M0,8 L9.37969414,9.33964512 C9.34913812,9.55536964 9.33333333,9.77583912 9.33333333,10 C9.33333333,10.2241609 9.34913812,10.4446304 9.37969414,10.6603549 L0,12 L0,8 Z M28,8 L28,12 L18.6203059,10.6603549 C18.6508619,10.4446304 18.6666667,10.2241609 18.6666667,10 C18.6666667,9.77583912 18.6508619,9.55536964 18.6203059,9.33964512 L28,8 Z M1.96165435,-3.53064057 L10.8980108,6.51346912 C10.6409116,6.74237577 10.4092984,6.99929219 10.2079601,7.27942976 L-0.714868071,-0.558061264 L1.96165435,-3.53064057 Z M26.0383456,-3.53064057 L28.7148681,-0.558061264 L17.7920399,7.27942976 C17.5907016,6.99929219 17.3590884,6.74237577 17.1019892,6.51346912 L26.0383456,-3.53064057 Z M16,-3.95239397e-14 L14.9150306,5.42300662 C14.6191408,5.36418208 14.313173,5.33333333 14,5.33333333 C13.6864744,5.33333333 13.3801701,5.3642516 13.0839698,5.42320546 L12,-3.95239397e-14 L16,-3.95239397e-14 Z",
    id: "Rectangle-346",
    fill: "#FFE94F",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/MK.e35adc7245b4f2d2d8ed5addcee52660.svg";
export { ForwardRef as ReactComponent };